import axios from "axios";
import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Onboarding from "./components/Accounts/Onboarding";
import UserProfileConfigLogin from "./components/UserProfileConfigLogin";
import SignUp from "./pages/Account/SignUp";
import VerifyEmail from "./pages/Account/VerifyEmail";
import ErrorPage from "./pages/ErrorPage";
import ConnectBackend from "./pages/LogRig/ConnectBackend";
import Login from "./pages/LogRig/LoginConnect";
import store from "./redux/store";
import "./tailwind-output.css";

function App() {
  const navigate = useLocation();
  const navigateTo = useNavigate();
  const location = useLocation();
  const [authCode, setAuthCode] = useState(null);
  const [accessToken, setAccessToken] = useState(null);

  // Add dynamic favicon and icons based on hostname
  useEffect(() => {
    const isEmpfehlio = window.location.hostname.startsWith('empfehlio');
    
    // Update favicon and title
    const favicon = document.querySelector("link[rel='icon']");
    const titleID = document.getElementById("title_website");
    if (titleID) {
      titleID.textContent = isEmpfehlio ? 'Empfehlio Connect' : 'Truzzer Connect';
    }

    // Helper function to check if file exists
    const checkFileExists = async (url) => {
      try {
        const response = await fetch(url, { method: 'HEAD' });
        return response.ok;
      } catch (error) {
        console.error(`Failed to check file: ${url}`, error);
        return false;
      }
    };

    // Update all icons and manifest
    const updateIcons = async () => {
      if (favicon) {
        const faviconPath = isEmpfehlio ? '/empfehlio_favicon.ico' : '/favicon.ico';
        if (await checkFileExists(faviconPath)) {
          favicon.href = faviconPath;
        }
      }

      const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
      if (appleIcon) {
        const applePath = isEmpfehlio ? '/empfehlio_logo_192.png' : '/logo192.png';
        if (await checkFileExists(applePath)) {
          appleIcon.href = applePath;
        }
      }

      const manifest = document.querySelector("link[rel='manifest']");
      if (manifest) {
        const manifestPath = isEmpfehlio ? '/manifest_empfehlio.json' : '/manifest_truzzer.json';
        if (await checkFileExists(manifestPath)) {
          manifest.href = manifestPath;
        }
      }
    };

    updateIcons();
  }, []);

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  };
  useEffect(() => {
    const findUserRoles = async (accessToken) => {
      try {
        const response = await axios.post("/api/user-roles", {
          accessToken: accessToken,
        });
        return response.data;
      } catch (error) {
        console.error("Failed to get user roles", error);
      }
    };
    function setCookieExpires(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/; secure; samesite=strict`;
    }
    const redirectToLogin = async () => {
      if (accessToken) {
        const userInfo = await findUserRoles(accessToken);
        if (userInfo.template.website_flag === 0) {
          if (window.location.hostname !== "empfehlio.ekomiapps.de") {
            navigateTo(
              `/truzzer${userInfo.user.username}-truzzer${userInfo.user.id}-config`
            );
          } else {
            setCookieExpires("landingpageAuthCode", "", -1);
            setCookieExpires("landingpageAccessToken", "", -1);
            navigateTo("/login");
          }
        } else if (userInfo.template.website_flag === 1) {
          if (window.location.hostname !== "truzzer.ekomiapps.de") {
            navigateTo(
              `/empfehlio${userInfo.user.username}-empfehlio${userInfo.user.id}-config`
            );
          } else {
            setCookieExpires("landingpageAuthCode", "", -1);
            setCookieExpires("landingpageAccessToken", "", -1);
            navigateTo("/login");
          }
        }
        setCookieExpires("landingpageAuthCode", "", -1);
      }
    };
    if (location.pathname === "/") {
      redirectToLogin();
    }
  }, [accessToken]);
  useEffect(() => {
    const authCodeValue = getCookie("landingpageAuthCode");
    const accessTokenValue = getCookie("landingpageAccessToken");
    if (authCodeValue) {
      setAuthCode(authCodeValue);
      navigateTo("/login");
    }
    if (accessTokenValue) {
      setAccessToken(accessTokenValue);
    } else {
      if (location.pathname === "/") {
        navigateTo("/login");
      }
    }
  }, []);

  return (
    <Provider store={store}>
      <Routes>
        <Route path="/auth/ekomi/callback" element={<ConnectBackend />} />
        <Route path="/login" element={<Login />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/error-page" element={<ErrorPage />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/:path" element={<UserProfileConfigLogin />} />
      </Routes>
    </Provider>
  );
}

export default App;
